<script lang="ts" setup>
import ErrorView from '@/components/Error/ErrorView.vue'

const { isDesktop } = useResponsive()

const layout = isDesktop.value ? 'default' : 'mobile'
</script>

<template>
  <app-root>
    <NuxtLayout :name="layout">
      <error-view />
    </NuxtLayout>
  </app-root>
</template>
